/* Vatoyum — vatoyum-sky.js
   Resize sky stage to match full page height,
   then distribute photos evenly across the page */
 
(function() {
  var stage = document.getElementById('skyStage');
  if (!stage) return;
 
  function resize() {
    var pageH = Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight
    );
    stage.style.height = pageH + 'px';
 
    var photos = stage.querySelectorAll('.sky-photo');
    if (photos.length === 0) return;
 
    // Each photo covers its share of the page height
    // Add 40vh overlap for blending
    var overlap = window.innerHeight * 0.4;
    var eachH = (pageH + overlap * (photos.length - 1)) / photos.length;
 
    photos.forEach(function(p) {
      p.style.height = Math.ceil(eachH) + 'px';
    });
  }
 
  resize();
  window.addEventListener('resize', resize);
  window.addEventListener('load', function() {
    resize();
    setTimeout(resize, 1000);
  });
 
  /* ── Place hero-clouds at top of <body> so it sits at page top ── */
  var heroClouds = document.querySelector('.hero-clouds');
  if (heroClouds) {
    document.body.insertBefore(heroClouds, document.body.firstChild);
  }
})();